import type { Currency } from "@common/client"
import type { Option } from "@common/components/form/fields/select"

export const CURRENCIES = ["usd", "cad", "eur", "gbp", "aud"] as const

export const FALLBACK_CURRENCY: Currency = "usd"

export const CURRENCY_OPTIONS: readonly Option<Currency>[] = CURRENCIES.map(
  (value) => ({ label: value.toUpperCase(), value }),
)

export function formatCurrency(
  amount: number | string,
  currency: Currency,
): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency.toUpperCase(),
    currencyDisplay: "code",
  }).format(Number(amount))
}

export function formatCompactCurrency(
  amount: number | string,
  currency: Currency,
): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency.toUpperCase(),
    currencyDisplay: "code",
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(Number(amount))
}

export function currencyCode(currency: Currency): string {
  return currency.toUpperCase()
}
